import { TBlockType } from '../../components/NewbuildingsComparePage/parts/Cell';
import { INewbuildingsCompareBlock } from '../../types/newbuildingsCompare';

export function blockTypeDeterminer(block: INewbuildingsCompareBlock): TBlockType | undefined {
  if (block.rows.some(row => row.type === 'roomStats')) {
    return 'flats';
  }

  if (block.rows.some(row => row.type === 'infrastructure')) {
    return 'infrastructure';
  }

  return;
}
